import "./modules/jquery_global"
import "jquery.easing"
import "bootstrap3"
import "jquery.waitforimages"
import "owl.carousel"
import "./modules/wow_global"
import "./angle/scripts"
